/* Lichcards redesign 2026 — gedrag van de "lc-rd"-laag (26-09-2026).
   1. Horizontale rijen (homepage): pijlen scrollen per pagina, knoppen aan/uit aan de randen.
   2. Loep op de productfoto (muis): vergroot rond de cursor, zodat je de conditie kunt zien.
   3. Onderbalk op mobiel: "Kies je spel"-paneel, zoeken en winkelwagen openen de thema-lades,
      teller van de winkelwagen loopt mee.
   4. Duidelijkere plaatshouder in de zoekvelden van de header.
   5. Spel-navigatie in de filterzijbalk op desktop open, submenu's inklapbaar.
   6. Productfoto's met veel witruimte automatisch groter in productkaarten en het pre-orderblok (27-09-2026).
   Opmaak: assets/lc-rd.css. Alleen actief als <body> de klasse lc-rd heeft. */
(function () {
  'use strict';
  var body = document.body;
  if (!body || !body.classList.contains('lc-rd')) return;
  var cfg = window.lcRd || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Horizontale rijen ----------------------------------------------------- */
  var scrollerQueue = [], scrollerRaf = 0;
  function flushScrollers() {
    scrollerRaf = 0;
    var plans = [];
    scrollerQueue.splice(0).forEach(function (state) {
      if (!state.track.isConnected) return;
      var max = state.track.scrollWidth - state.track.clientWidth;
      var x = Math.abs(state.track.scrollLeft);
      plans.push({ state: state, atStart: x <= 2, atEnd: x >= max - 2, hideArrows: max <= 4 });
    });
    plans.forEach(function (plan) {
      var state = plan.state;
      if (!state.track.isConnected) return;
      if (state.prev && state.prev.disabled !== plan.atStart) state.prev.disabled = plan.atStart;
      if (state.next && state.next.disabled !== plan.atEnd) state.next.disabled = plan.atEnd;
      if (state.arrows && state.arrows.hidden !== plan.hideArrows) state.arrows.hidden = plan.hideArrows;
    });
  }
  function initScrollers(root) {
    (root || document).querySelectorAll('[data-rd-scroller]:not([data-rd-ready])').forEach(function (scroller) {
      scroller.setAttribute('data-rd-ready', '');
      var track = scroller.querySelector('.rd-scroller__track');
      var section = scroller.closest('.rd-section') || scroller.parentNode;
      var prev = section.querySelector('[data-rd-prev]');
      var next = section.querySelector('[data-rd-next]');
      var arrows = section.querySelector('[data-rd-arrows]');
      if (!track) return;
      var state = { track: track, prev: prev, next: next, arrows: arrows };
      var schedule = function () {
        if (!track.isConnected) return;
        if (scrollerQueue.indexOf(state) === -1) scrollerQueue.push(state);
        if (!scrollerRaf) scrollerRaf = requestAnimationFrame(flushScrollers);
      };
      var page = function (dir) {
        var first = track.querySelector(':scope > li');
        var step = first ? first.getBoundingClientRect().width : track.clientWidth / 4;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var per = Math.max(1, Math.floor((track.clientWidth + gap) / (step + gap)));
        track.scrollBy({ left: dir * per * (step + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      /* Eerste meting via de ResizeObserver (die meldt zich direct na de eerste opmaak) of het volgende beeldje:
         niet meteen bij het laden, want dan moet de browser de hele pagina vervroegd opmeten. */
      if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(track);
      else schedule();
    });
  }

  /* 2. Loep op de productfoto ------------------------------------------------ */
  class GalleryZoomControl extends HTMLElement {
    constructor() {
      super();
      this.frame = 0;
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.carousel = this.gallery?.querySelector('.swiper-main');
      this.button = this.querySelector('button');
      if (!this.carousel || !this.button) return;
      if (this.parentElement !== this.carousel) {
        this.carousel.appendChild(this);
        return;
      }
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver((records) => {
        if (!records.some((record) => record.type === 'childList' ||
          (record.target.classList.contains('swiper-slide') &&
            /(?:^|\s)swiper-slide-active(?:\s|$)/.test(record.oldValue || '') !==
            record.target.classList.contains('swiper-slide-active')))) return;
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.update();
        });
      });
      const wrapper = this.carousel.querySelector('.swiper-wrapper');
      if (wrapper) this.observer.observe(wrapper, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class'], attributeOldValue: true,
      });
      this.update();
      customElements.whenDefined('zoom-dialog').then(() => {
        if (this.isConnected) this.update();
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.button?.removeEventListener('click', this.onClick);
    }

    activeImage() {
      const wrapper = this.carousel?.querySelector('.swiper-wrapper');
      const slide = wrapper?.querySelector(':scope > .swiper-slide-active') || wrapper?.firstElementChild;
      return slide?.matches('.product-media-container--image.product-media-container--zoomable[data-zoom-index][data-zoom-target]')
        ? slide : null;
    }

    update() {
      const image = this.activeImage();
      const dialog = image ? this.gallery.querySelector(image.dataset.zoomTarget) : null;
      this.hidden = !image || !dialog;
      this.button.disabled = this.hidden || typeof dialog.open !== 'function';
    }

    onClick(event) {
      this.update();
      const image = this.activeImage();
      if (this.button.disabled || !image) return;
      const dialog = this.gallery.querySelector(image.dataset.zoomTarget);
      event.preventDefault();
      event.stopPropagation();
      Promise.resolve(dialog.open(Number(image.dataset.zoomIndex), event)).catch((error) => {
        console.warn('Unable to open the product image', error);
      });
    }
  }
  if (!customElements.get('gallery-zoom-control')) customElements.define('gallery-zoom-control', GalleryZoomControl);

  function initLoupe() {
    if (!body.classList.contains('template-product')) return;
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var gallery = document.querySelector('.product-information__media media-gallery');
    if (!gallery) return;

    var containers = Array.prototype.filter.call(
      gallery.querySelectorAll('.product-media-container--zoomable'),
      function (el) { return !el.closest('zoom-dialog, dialog'); }
    );
    if (!containers.length) return;

    /* Hint op de eerste foto */
    var first = containers[0];
    var hint = document.createElement('span');
    hint.className = 'rd-zoomhint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="m20 20-4.2-4.2M11 8.5v5M8.5 11h5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span></span>';
    hint.lastChild.textContent = fine ? (cfg.zoom || '') : (cfg.zoomTouch || '');
    if (hint.lastChild.textContent) {
      if (getComputedStyle(first).position === 'static') first.style.position = 'relative';
      first.appendChild(hint);
    }
    if (!fine) return;

    var hiRes = function (img) {
      var src = img.currentSrc || img.src || '';
      if (!src) return '';
      try {
        var u = new URL(src, window.location.href);
        u.searchParams.delete('height');
        u.searchParams.delete('crop');
        u.searchParams.set('width', '2000');
        return u.href;
      } catch (e) { return src; }
    };
    var drawnBox = function (img) {
      var r = img.getBoundingClientRect();
      var nw = img.naturalWidth, nh = img.naturalHeight;
      var fit = getComputedStyle(img).objectFit;
      if (!nw || !nh || (fit !== 'contain' && fit !== 'scale-down')) return r;
      var ir = nw / nh, br = r.width / r.height, w = r.width, h = r.height;
      if (ir > br) { h = w / ir; } else { w = h * ir; }
      return { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h };
    };

    containers.forEach(function (box) {
      var img = box.querySelector('img');
      if (!img) return;
      box.classList.add('rd-zoomable');
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      var lens = null, big = null, bigW = 0, raf = 0, ev = null, zoom = 2.5, active = false;
      var ensure = function () {
        if (lens) return;
        lens = document.createElement('span');
        lens.className = 'rd-loupe';
        lens.setAttribute('aria-hidden', 'true');
        box.appendChild(lens);
        var url = hiRes(img);
        big = new Image();
        big.decoding = 'async';
        big.onload = function () { bigW = big.naturalWidth; lens.style.backgroundImage = 'url("' + url + '")'; };
        big.src = url;
        lens.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
      };
      var draw = function () {
        raf = 0;
        if (!ev || !lens) return;
        var d = drawnBox(img);
        var x = ev.clientX - d.left, y = ev.clientY - d.top;
        if (ev.buttons || x < 0 || y < 0 || x > d.width || y > d.height) { lens.classList.remove('is-on'); box.classList.remove('is-zooming'); return; }
        var L = lens.offsetWidth || 220;
        zoom = bigW ? Math.max(2, Math.min(3.2, bigW / d.width)) : 2.5;
        var b = box.getBoundingClientRect();
        lens.style.left = (ev.clientX - b.left - L / 2) + 'px';
        lens.style.top = (ev.clientY - b.top - L / 2) + 'px';
        lens.style.backgroundSize = (d.width * zoom) + 'px ' + (d.height * zoom) + 'px';
        lens.style.backgroundPosition = (-(x * zoom - L / 2)) + 'px ' + (-(y * zoom - L / 2)) + 'px';
        lens.classList.add('is-on');
        box.classList.add('is-zooming');
      };
      box.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse') return; active = true; ensure(); });
      box.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !active) return;
        ev = e;
        if (!raf) raf = requestAnimationFrame(draw);
      }, { passive: true });
      var off = function () { active = false; if (lens) lens.classList.remove('is-on'); box.classList.remove('is-zooming'); };
      box.addEventListener('pointerleave', off);
      box.addEventListener('pointerdown', off);
      window.addEventListener('scroll', off, { passive: true });
    });
  }

  /* 3. Onderbalk op mobiel -------------------------------------------------- */
  function initBottomNav() {
    var nav = document.querySelector('[data-rd-bnav]');
    if (!nav) return;
    var lastFocus = null;
    var openSheet = function (sheet, opener) {
      if (!sheet) return;
      lastFocus = opener || document.activeElement;
      sheet.lcOpening = true;
      sheet.hidden = false;
      body.classList.add('rd-sheet-open');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        if (sheet.hidden || !sheet.lcOpening) return;
        sheet.classList.add('is-open');
        var panel = sheet.querySelector('.rd-sheet__panel');
        if (panel && window.lcModalFocus) {
          sheet.lcReleaseFocus = window.lcModalFocus(sheet, panel, panel.querySelector('[data-rd-sheet-close]'), lastFocus, function () { closeSheet(sheet); });
        } else if (panel) panel.focus({ preventScroll: true });
      });
    };
    var closeSheet = function (sheet) {
      if (!sheet || sheet.hidden) return;
      sheet.lcOpening = false;
      sheet.classList.remove('is-open');
      body.classList.remove('rd-sheet-open');
      document.querySelectorAll('[data-rd-sheet-open="' + sheet.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () {
        if (sheet.classList.contains('is-open')) return;
        sheet.hidden = true;
        if (sheet.lcReleaseFocus) { sheet.lcReleaseFocus(); sheet.lcReleaseFocus = null; }
        else if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }, reduceMotion ? 0 : 320);
    };
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-rd-sheet-open]');
      if (opener) {
        e.preventDefault();
        var sheet = document.getElementById(opener.getAttribute('data-rd-sheet-open'));
        if (sheet && !sheet.hidden) closeSheet(sheet); else openSheet(sheet, opener);
        return;
      }
      var closer = e.target.closest('[data-rd-sheet-close]');
      if (closer) { e.preventDefault(); closeSheet(closer.closest('[data-rd-sheet]')); return; }
      var searchOpener = e.target.closest('[data-rd-open-search]');
      if (searchOpener) {
        var searchDrawer = document.getElementById('Drawer-Search');
        var s = document.querySelector('side-drawer-opener[data-side-drawer="#Drawer-Search"] button');
        if (searchDrawer && typeof searchDrawer.open === 'function') { searchDrawer.open(searchOpener); }
        else if (s) { s.click(); } else { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search'; }
        return;
      }
      var cart = e.target.closest('[data-rd-open-cart]');
      if (cart) {
        var c = document.querySelector('side-drawer-opener[data-side-drawer="#Cart-Drawer"] button, #header-component .header__icon--cart');
        if (c && document.getElementById('Cart-Drawer')) { e.preventDefault(); c.click(); }
      }
    });
    /* Logo's in het spelpaneel alvast laden zodra iemand de knop aanraakt */
    var warm = function (e) {
      var opener = e.target.closest && e.target.closest('[data-rd-sheet-open]');
      if (!opener) return;
      var sheet = document.getElementById(opener.getAttribute('data-rd-sheet-open'));
      if (sheet) sheet.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    };
    document.addEventListener('pointerdown', warm, { passive: true });
    document.addEventListener('focusin', warm);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('[data-rd-sheet]:not([hidden])');
      if (open) closeSheet(open);
    });
    /* Veeg omlaag om het paneel te sluiten */
    document.querySelectorAll('[data-rd-sheet] .rd-sheet__panel').forEach(function (panel) {
      var y0 = null;
      panel.addEventListener('touchstart', function (e) { y0 = panel.scrollTop <= 0 ? e.touches[0].clientY : null; }, { passive: true });
      panel.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        var dy = e.touches[0].clientY - y0;
        if (dy > 0) panel.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      panel.addEventListener('touchend', function (e) {
        if (y0 === null) return;
        var dy = (e.changedTouches[0].clientY - y0);
        panel.style.transform = '';
        y0 = null;
        if (dy > 90) closeSheet(panel.closest('[data-rd-sheet]'));
      });
    });

    /* Winkelwagenteller volgt de header */
    var count = nav.querySelector('[data-rd-cart-count]');
    var bubble = document.getElementById('cart-icon-bubble');
    if (count && bubble) {
      var sync = function () {
        var el = bubble.querySelector('.cart-count-bubble [aria-hidden="true"], .cart-count-bubble span, .cart-count-bubble');
        var n = el ? parseInt((el.textContent || '').replace(/\D+/g, ''), 10) : 0;
        if (isNaN(n)) n = 0;
        count.textContent = n > 99 ? '99+' : String(n);
        count.classList.toggle('is-empty', n === 0);
      };
      new MutationObserver(sync).observe(bubble, { childList: true, subtree: true, characterData: true });
    }
  }

  /* 4. Duidelijkere plaatshouder in de zoekvelden van de header */
  function initSearchPlaceholder() {
    if (!cfg.searchPh) return;
    document.querySelectorAll('#header-component .header__search--inline input[type="search"], #Drawer-Search input[type="search"]').forEach(function (input) {
      input.setAttribute('placeholder', cfg.searchPh);
    });
  }

  /* 5. Spel-navigatie in de filterzijbalk op desktop standaard open */
  /* Spelnavigatie in de filterzijbalk (blok "Categorieën"): op desktop standaard open, maar alleen
     de spellen zelf; het submenu van het huidige spel klapt open, de rest via het pijltje. */
  function initGameNav() {
    var roots = document.querySelectorAll('.facets-wrapper accordion-custom.blog-post__category');
    if (!roots.length) return;
    var strip = function (p) { return (p || '/').replace(/^\/(en|de|fr|es|it)(?=\/|$)/, '').replace(/\/$/, '') || '/'; };
    var path = strip(location.pathname);
    var lower = path.toLowerCase();
    var groups = [['pokemon'], ['yu-gi-oh', 'yugioh'], ['magic', 'mtg'], ['accessoire']];
    var wide = window.matchMedia && window.matchMedia('(min-width: 1025px)').matches;
    roots.forEach(function (root) {
      if (root.hasAttribute('data-rd-nav')) return;
      root.setAttribute('data-rd-nav', '');
      var details = root.querySelector(':scope > details');
      if (wide && details && !root.hasAttribute('data-lc-compact-accessory-categories') && !details.hasAttribute('open')) details.setAttribute('open', '');
      var items = Array.prototype.slice.call(root.querySelectorAll('.blog-post__category-list > .blog-post__category-list-item'));
      var found = false;
      items.forEach(function (li) {
        var own = li.querySelector(':scope > a[href]');
        if (own && strip(new URL(own.getAttribute('href'), location.origin).pathname) === path) li.classList.add('rd-current');
        if (!li.querySelector(':scope > .dropdown-category-list') || !li.querySelector(':scope > .icon-dropdown')) return;
        li.classList.add('rd-has-sub');
        if (found) return;
        var links = li.querySelectorAll('a[href]');
        for (var i = 0; i < links.length; i++) {
          var u = new URL(links[i].getAttribute('href'), location.origin);
          if (strip(u.pathname) === path && (!u.search || u.search === location.search)) { li.classList.add('rd-open', 'rd-current'); found = true; break; }
        }
      });
      if (!found) {
        items.some(function (li) {
          if (!li.classList.contains('rd-has-sub')) return false;
          var a = li.querySelector(':scope > a[href]');
          var h = a ? a.getAttribute('href').toLowerCase() : '';
          if (h.indexOf('verkopen') > -1) return false;
          return groups.some(function (g) {
            var hit = g.some(function (k) { return h.indexOf(k) > -1; }) && g.some(function (k) { return lower.indexOf(k) > -1; });
            if (hit) li.classList.add('rd-open', 'rd-current');
            return hit;
          });
        });
      }
      items.forEach(function (li) {
        var t = li.querySelector(':scope > .icon-dropdown');
        if (t && li.classList.contains('rd-has-sub')) t.setAttribute('aria-expanded', li.classList.contains('rd-open') ? 'true' : 'false');
      });
    });
    var toggleSel = '[data-rd-nav] .blog-post__category-list-item.rd-has-sub > .icon-dropdown';
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest(toggleSel);
      if (!t) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var open = t.parentElement.classList.toggle('rd-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target.closest && e.target.closest(toggleSel);
      if (!t) return;
      e.preventDefault();
      t.click();
    }, true);
  }

  /* 6. Productfoto's met veel witruimte automatisch groter -------------------
     Veel packshots (boxen, decks, tins) staan klein midden op een grote witte foto. We meten per foto
     waar het product staat (alles wat niet (bijna) wit of doorzichtig is) en vergroten de foto zo dat het
     product ~90% van het vak vult. Kaartscans en foto's zonder witte rand blijven zoals ze zijn.
     Werkt met de losse CSS-eigenschappen scale/translate, zodat hover-effecten van het thema (transform)
     gewoon blijven werken. Lukt het meten niet (bijv. foto van een ander domein), dan verandert er niets. */
  var TRIM_SEL = '.product-card-wrapper .card__media img, .rd-hero__img, .rd-mini__img img';
  var TRIM_FILL = 0.9, TRIM_MAX = 2.4, TRIM_MIN = 1.06;
  var trimRO = null;
  function trimMeasure(img) {
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return null;
    var S = 64;
    var cw = nw >= nh ? S : Math.max(8, Math.round(S * nw / nh));
    var ch = nh >= nw ? S : Math.max(8, Math.round(S * nh / nw));
    var c = document.createElement('canvas');
    c.width = cw; c.height = ch;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;
    var d;
    try {
      ctx.drawImage(img, 0, 0, cw, ch);
      d = ctx.getImageData(0, 0, cw, ch).data;
    } catch (err) { return null; }
    var cols = new Array(cw).fill(0), rows = new Array(ch).fill(0);
    for (var y = 0; y < ch; y++) {
      for (var x = 0; x < cw; x++) {
        var i = (y * cw + x) * 4;
        if (d[i + 3] < 24) continue;
        if (d[i] > 238 && d[i + 1] > 238 && d[i + 2] > 238) continue;
        cols[x]++; rows[y]++;
      }
    }
    var minC = Math.max(1, Math.round(ch * 0.02)), minR = Math.max(1, Math.round(cw * 0.02));
    var x0 = -1, x1 = -1, y0 = -1, y1 = -1, k;
    for (k = 0; k < cw; k++) if (cols[k] >= minC) { x0 = k; break; }
    for (k = cw - 1; k >= 0; k--) if (cols[k] >= minC) { x1 = k; break; }
    for (k = 0; k < ch; k++) if (rows[k] >= minR) { y0 = k; break; }
    for (k = ch - 1; k >= 0; k--) if (rows[k] >= minR) { y1 = k; break; }
    if (x0 < 0 || y0 < 0 || x1 < x0 || y1 < y0) return null;
    /* een pixel marge rondom, zodat we nooit een randje van het product afsnijden */
    return {
      x0: Math.max(0, x0 - 1) / cw, x1: Math.min(cw, x1 + 2) / cw,
      y0: Math.max(0, y0 - 1) / ch, y1: Math.min(ch, y1 + 2) / ch
    };
  }
  function trimReset(img) {
    img.style.removeProperty('scale');
    img.style.removeProperty('translate');
    img.classList.remove('rd-trimmed');
  }
  /* Alleen lezen: berekent vergroting en verschuiving (of null = niets doen). */
  function trimPlan(img) {
    var box = img.__rdTrimBox;
    if (!box) return null;
    var bw = img.clientWidth, bh = img.clientHeight;
    if (!bw || !bh) return false; /* (nog) niet zichtbaar: niets aanraken, de ResizeObserver komt terug */
    var cs = getComputedStyle(img);
    var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0;
    var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var ew = bw - pl - pr, eh = bh - pt - pb;
    if (ew <= 0 || eh <= 0) return null;
    var r = img.naturalWidth / img.naturalHeight, cw, ch;
    if (cs.objectFit === 'cover') {
      if (ew / eh > r) { cw = ew; ch = ew / r; } else { ch = eh; cw = eh * r; }
    } else if (cs.objectFit === 'contain' || cs.objectFit === 'scale-down') {
      if (ew / eh > r) { ch = eh; cw = eh * r; } else { cw = ew; ch = ew / r; }
    } else { return null; }
    var ox = pl + (ew - cw) / 2, oy = pt + (eh - ch) / 2;
    var X0 = ox + box.x0 * cw, X1 = ox + box.x1 * cw, Y0 = oy + box.y0 * ch, Y1 = oy + box.y1 * ch;
    /* bij "cover" alleen het zichtbare deel meetellen */
    X0 = Math.max(X0, pl); X1 = Math.min(X1, pl + ew); Y0 = Math.max(Y0, pt); Y1 = Math.min(Y1, pt + eh);
    var BW = X1 - X0, BH = Y1 - Y0;
    if (BW <= 0 || BH <= 0) return null;
    var s = Math.min(TRIM_FILL * ew / BW, TRIM_FILL * eh / BH, TRIM_MAX);
    if (!(s >= TRIM_MIN)) return null;
    var tx = (bw / 2 - (X0 + X1) / 2) * s, ty = (bh / 2 - (Y0 + Y1) / 2) * s;
    return {
      scale: s.toFixed(3),
      translate: (tx / bw * 100).toFixed(3) + '% ' + (ty / bh * 100).toFixed(3) + '%',
      /* uitgelichte foto: iets scherpere versie laden nu hij groter getoond wordt */
      sizes: img.classList.contains('rd-hero__img') && img.srcset ? Math.ceil(bw * s) + 'px' : ''
    };
  }
  /* Alleen schrijven. */
  function trimWrite(img, plan) {
    if (plan === false) { /* nog niet zichtbaar: de ResizeObserver meldt zich zodra het vak een maat krijgt */
      if (trimRO && !img.__rdTrimObs) { img.__rdTrimObs = true; trimRO.observe(img); }
      return;
    }
    if (!plan) { trimReset(img); }
    else {
      if (img.style.getPropertyValue('scale') !== plan.scale) img.style.setProperty('scale', plan.scale);
      if (img.style.getPropertyValue('translate') !== plan.translate) img.style.setProperty('translate', plan.translate);
      img.classList.add('rd-trimmed');
      if (plan.sizes && img.getAttribute('sizes') !== plan.sizes) img.setAttribute('sizes', plan.sizes);
    }
    if (trimRO && !img.__rdTrimObs) { img.__rdTrimObs = true; trimRO.observe(img); }
  }
  /* Werkverdeling, zodat het vergroten de pagina nooit ophoudt (ook niet op trage telefoons):
     1. de foto laten decoderen buiten de hoofdtaak (img.decode);
     2. meten (canvas) alleen als de browser even niets te doen heeft (requestIdleCallback);
     3. per beeldje (requestAnimationFrame) eerst alle maten lezen, dan alles schrijven. */
  var trimQueue = [], trimRaf = 0, measureQueue = [], idleId = 0;
  var ric = window.requestIdleCallback
    ? function (cb) { return window.requestIdleCallback(cb, { timeout: 1500 }); }
    : function (cb) { return setTimeout(function () { cb({ timeRemaining: function () { return 8; } }); }, 40); };
  function trimRequest(img) {
    if (!img || img.getAttribute('data-rd-trim') === 'off') return;
    if (!img.complete || !img.naturalWidth) return;
    var key = img.currentSrc || img.src;
    if (img.__rdTrimKey === key) { trimSchedule(img); return; }
    if (img.__rdTrimPending === key) return;
    img.__rdTrimPending = key;
    var go = function () {
      if (img.__rdTrimPending !== key) return;
      if (measureQueue.indexOf(img) === -1) measureQueue.push(img);
      if (!idleId) idleId = ric(measureRun);
    };
    if (img.decode) img.decode().then(go, go); else go();
  }
  function measureRun(deadline) {
    idleId = 0;
    var n = 0;
    while (measureQueue.length && (n === 0 || deadline.timeRemaining() > 6)) {
      var img = measureQueue.shift();
      n++;
      if (!img.isConnected || !img.complete || !img.naturalWidth) continue;
      var key = img.currentSrc || img.src;
      img.__rdTrimPending = null;
      img.__rdTrimKey = key;
      img.__rdTrimBox = trimMeasure(img);
      trimSchedule(img);
    }
    if (measureQueue.length) idleId = ric(measureRun);
  }
  function trimSchedule(img) {
    if (trimQueue.indexOf(img) === -1) trimQueue.push(img);
    if (!trimRaf) trimRaf = requestAnimationFrame(trimFlush);
  }
  function trimFlush() {
    trimRaf = 0;
    var batch = trimQueue.splice(0, 12), plans = [];
    batch.forEach(function (img) {
      if (!img.isConnected) return;
      var key = img.currentSrc || img.src;
      if (img.__rdTrimKey !== key) { trimRequest(img); return; }
      plans.push([img, trimPlan(img)]);
    });
    plans.forEach(function (p) { trimWrite(p[0], p[1]); });
    if (trimQueue.length) trimRaf = requestAnimationFrame(trimFlush);
  }
  function initTrim(root) {
    if (!window.CanvasRenderingContext2D || !window.requestAnimationFrame) return;
    if (!trimRO && window.ResizeObserver) {
      trimRO = new ResizeObserver(function (entries) {
        entries.forEach(function (en) { if (en.target.__rdTrimKey) trimSchedule(en.target); });
      });
    }
    if (!document.__rdTrimLoad) {
      document.__rdTrimLoad = true;
      document.addEventListener('load', function (e) {
        var t = e.target;
        if (t && t.tagName === 'IMG' && t.matches && t.matches(TRIM_SEL)) trimRequest(t);
      }, true);
    }
    Array.prototype.forEach.call((root || document).querySelectorAll(TRIM_SEL), trimRequest);
  }

  var start = function () {
    initSearchPlaceholder();
    initGameNav();
    initScrollers();
    initLoupe();
    initBottomNav();
    initTrim();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { initScrollers(e.target); initTrim(e.target); });
})();
